import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { IconInfo, withTooltip, TOOLTIP_HORIZONTAL_ALIGNMENTS, TOOLTIP_VERTICAL_ALIGNMENTS, THEMES } from 'cdk-radial';
import { SlimDropdownMenu } from '../../../dropdown/DropdownMenu';

const CustomCellRendererDropDown = cmfNumbers => {
  const { rowIndex } = cmfNumbers;

  const state = useSelector(state => state);
  let selectedLocationsWithCMF = state && state.selectLocationsSlice && state.selectLocationsSlice.selectedLocationsWithCMFNumber;
  let cmfNumberValues = cmfNumbers && cmfNumbers.value && cmfNumbers.value.cmfData || [];

  const onCMFSelected = cmfNumbers?.value?.onCMFSelected;
  const location = cmfNumbers?.value?.location;
  const entityId = cmfNumbers?.value?.entityId;
  const address = cmfNumbers?.value?.address;
  const isSubscribed = cmfNumbers?.value?.isSubscribed;
  const isRemoveLocations = cmfNumbers?.value?.isRemoveLocations;

  const selectedCMF = Array.isArray(selectedLocationsWithCMF) && selectedLocationsWithCMF.filter(locationWithCMF => entityId === locationWithCMF.entityId);

  const hasError = useMemo(() => {
    if (selectedLocationsWithCMF && selectedLocationsWithCMF.length) {
      return !!(selectedCMF.length && !selectedCMF[0].cmfNumber);
    }
    return false;
  }, [selectedLocationsWithCMF]);

  let subscribedCMFs = cmfNumbers && cmfNumbers.value && cmfNumbers.value.subscribedCMFs;

  let subscribedCMF = isSubscribed &&
    cmfNumberValues.filter(value => {
      return subscribedCMFs.includes(value.value)
    })[0];

  const [cmfNumber, setCMFNumber] = useState((selectedCMF[0] && selectedCMF[0].cmfNumber && {
    value: selectedCMF[0].cmfNumber,
    label: selectedCMF[0].cmfNumber
  }) || '');

  useEffect(
    () => cmfNumbers &&
      cmfNumbers.value &&
      cmfNumbers.value.setDefaultCMF(
        entityId,
        selectedCMF[0] && selectedCMF[0].cmfNumber
      ),
    []
  );

  const cannotSelectCmf = (cmfNumberValues && cmfNumberValues.length === 1)
    || isSubscribed
    || isRemoveLocations;

  return cannotSelectCmf ? (
    <div>
      {isSubscribed || isRemoveLocations
        ? ((subscribedCMF && subscribedCMF.value) || 'N/A')
        : cmfNumberValues[0] && cmfNumberValues[0].value}
    </div>
  ) : (
    <>
      <SlimDropdownMenu
        inputId={`select-locations-${rowIndex}`}
        dataTestId="select-locations"
        options={cmfNumberValues}
        value={cmfNumber}
        onChange={cmfNumber => {
          setCMFNumber(cmfNumber);
          onCMFSelected(entityId, location, address, cmfNumber.value);
        }}
        isDisabled={isSubscribed}
        enableCustomValidation
        hasError={hasError}
        width="108px"
      />
      <div style={{padding:'3px'}}>
        <ToolTip/>
      </div>
    </>
  );
};

export default CustomCellRendererDropDown;

const tooltipProps = {
  id: 'tooltip-id-2',
  text: "If you are not sure of the correct CMF #, speak with your Dealer's Enterprise Administrator or contact CDK Customer Care at 866.668.5394, option 8",
  theme: THEMES.LIGHT
};

const ToolTip = () => {
  return <div css="display: flex;">
      <ComponentWithTooltip horizontalAlignment={TOOLTIP_HORIZONTAL_ALIGNMENTS.LEFT} marginAroundElement={8} verticalAlignment={TOOLTIP_VERTICAL_ALIGNMENTS.TOP} />
    </div>;
}

const ComponentToRender = ({
  ...props
}) => {
  return <IconInfo {...props} />;
};

const ComponentWithTooltip = withTooltip(ComponentToRender, tooltipProps);
